/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateWatchersRequestBody
 */
export interface UpdateWatchersRequestBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateWatchersRequestBody
     */
    userIds: Array<string> | null;
}

/**
 * Check if a given object implements the UpdateWatchersRequestBody interface.
 */
export function instanceOfUpdateWatchersRequestBody(value: object): value is UpdateWatchersRequestBody {
    if (!('userIds' in value) || value['userIds'] === undefined) return false;
    return true;
}

export function UpdateWatchersRequestBodyFromJSON(json: any): UpdateWatchersRequestBody {
    return UpdateWatchersRequestBodyFromJSONTyped(json, false);
}

export function UpdateWatchersRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateWatchersRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'userIds': json['userIds'] == null ? null : json['userIds'],
    };
}

export function UpdateWatchersRequestBodyToJSON(json: any): UpdateWatchersRequestBody {
    return UpdateWatchersRequestBodyToJSONTyped(json, false);
}

export function UpdateWatchersRequestBodyToJSONTyped(value?: UpdateWatchersRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userIds': value['userIds'],
    };
}

